export default __webpack_public_path__ + "c0871b02ed1c40fa0073b3e7b8d4835a.svg";